export const CREATEADMIN_IN_PROGRESS = "CREATEADMIN_IN_PROGRESS";
export const CREATEADMIN_COMPLETE = "CREATEADMIN_COMPLETE";
export const CREATEADMIN_FAILURE = "CREATEADMIN_FAILURE";
export const GET_EXISTING_ADMIN_IN_PROGRESS = "GET_EXISTING_ADMIN_IN_PROGRESS";
export const GET_EXISTING_ADMIN_SUCCESS = "GET_EXISTING_ADMIN_SUCCESS";
export const GET_EXISTING_ADMIN_FAILURE = "GET_EXISTING_ADMIN_FAILURE";
export const DELETE_ADMIN_IN_PROGRESS = "DELETE_ADMIN_IN_PROGRESS"
export const DELETE_ADMIN_SUCCESS = "DELETE_ADMIN_SUCCESS"
export const DELETE_ADMIN_FAILED = "DELETE_ADMIN_FAILED"